import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTicketPriority } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useUpdateTicketPriority = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ priorityId, priorityData }) => updateTicketPriority(priorityId, priorityData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['ticket-priorities'] });
            toast.success('Priorité modifiée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la modification de la priorité');
        },
    });
};
